package com.eladfinish.bible.contest.screens.openQuestions.usecases

import com.eladfinish.bible.contest.extensions.getItemsPrefixedByNumbers
import com.eladfinish.bible.contest.network.spreadsheet.GoogleSheetRowHeadersAndValues
import com.eladfinish.bible.contest.network.spreadsheet.SpreadsheetApi
import com.eladfinish.bible.contest.network.spreadsheet.handleApiResult
import com.eladfinish.bible.contest.network.spreadsheet.toSpreadsheetMatrixWithHeaders
import com.eladfinish.bible.contest.screens.openQuestions.getTranslatedLanguage
import com.eladfinish.bible.contest.screens.openQuestions.model.LinkTopicItemEntry
import com.eladfinish.bible.contest.utils.spreadsheet.getId
import kotlinx.coroutines.flow.first
import kotlinx.coroutines.flow.map

//NumbersInBible
//Ministry of Education Questions
/*
this class intended for topics that contain links to other sheets
טבלת נושאים שמכילה קישורים לטבלאות אחרות, כגון:
מספרים לפי ספרים
שאלות לפי ספרים - משרד החינוך
 */

class GetTopicWithLinksUseCase(
    private val spreadsheetApi: SpreadsheetApi,
) {

    suspend operator fun invoke(
        url: String,
        sheetId: String,
    ): Result<Pair<List<LinkTopicItemEntry>, List<String>>> =
        spreadsheetApi.getDataFromSpreadsheet(spreadsheetId = url.getId(), sheetId = sheetId)
            .handleApiResult { result ->
                result.data.toSpreadsheetMatrixWithHeaders()
                    .map { list: List<GoogleSheetRowHeadersAndValues> ->
                        list.map {
                            LinkTopicItemEntry(it.listNoIndexes)
                        }
                    }
                    .map { items: List<LinkTopicItemEntry> ->
                        val books = items
                            .map {
                                it.book + when {
                                    it.language?.isNotEmpty() == true -> " (" + getTranslatedLanguage(it.language!!) + ")"
                                    else -> ""
                                }
                            }
                            .getItemsPrefixedByNumbers()

                        Result.success(items to books)
                    }
                    .first()
            }

}
